import axiosInstance from "../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";

const headers = {
  accept: "*/*",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};
export const manageAppSetting = async (payload) => {
  const formattedPayload = {
    ...payload,
    MaxCartValueForFreeShipping: Number(payload.MaxCartValueForFreeShipping),
    StandardShippingCost: Number(payload.StandardShippingCost),
  };

  return await axiosInstance.post(
    "master-settings/app-setting",
    formattedPayload,
    {
      headers,
    }
  );
};

export const fetchAppSetting = async () => {
  const response = await axiosInstance.get(`master-settings/app-setting`, {
    headers,
  });
  return response.data;
};
